<template>
  <div style="padding: -30px">
    <iframe
      :src="src"
      width="100%"
      :height="ModelHeight"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: window.location.origin + "/#/discussTheTopicModel",
      ModelHeight: document.body.clientHeight - 90
    };
  },
  created() {
    this.flushSession();
  },
  methods: {},
  mounted() {
    this.ModelHeight = document.body.clientHeight - 90;
  }
};
</script>
